/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IProgramSearch {
        occupations: any[];
        searchTerm: string;
        restResult: IRestResult<IProgramResult>
        page: number;
        pageSize: number;
        careerClusters: ICareerCluster[];
        searchType: string;
        searchId: number;
        loading: boolean;
    }

    interface IProgramResult {
        id: number;
        cipCode: string;
        programName: string;
        description: string;
        url: string;
        urlName: string;
    }

    interface ICareerCluster {
        id: number;
        code: number;
        title: string;
        description: string;
    }

    class ProgramSearch implements IProgramSearch {
        static controllerId: string = "programSearch";
        static $inject: string[] = ["$scope", "common", "config", "Restangular", "$location", "$routeParams", "$q"];

        occupations: any[];
        searchTerm: string;
        restResult: IRestResult<any>
        page: number;
        pageSize: number = 10;
        careerClusters: ICareerCluster[];
        baseUrl: string;
        careerClusterId: number;
        searchType: string;
        searchId: number;
        loading: boolean = true;
        occCode: string;

        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;


        constructor(private $scope: ng.IScope, private common: ICommonFactory, private config: IConfig, private Restangular: Restangular.IService, private $location: ng.ILocationService, private $routeParams: ng.route.IRouteParamsService, private $q: ng.IQService) {

            this.log = common.logger.getLogFn(ProgramSearch.controllerId);
            this.logError = common.logger.getLogFn(ProgramSearch.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(ProgramSearch.controllerId, "success");
            this.baseUrl = config.cfncUrl;

            if (Object.keys($location.search()).length > 0) {
                this.searchTerm = $location.search().s;
                this.page = $location.search().p;

                this.searchType = $location.search().searchType;
                this.searchId = $location.search().searchId;
                this.occCode = $location.search().occCode;


                if ((this.searchType && this.searchId) || this.occCode) {
                    var params = this.getParams();
                    this.getCareers(params);
                }
                else if (this.searchTerm) {
                    this.search(this.page);
                }
            }

            this.$scope.$on("$routeUpdate", () => {
                if ($location.hash()) {
                    this.getState();
                }
                else if (Object.keys($location.search()).length > 0) {
                    this.getState();
                }
                else {
                    this.restResult = null;
                }
            });



            this.activate();
        }


        activate() {
            var promises = [this.getCareerClusters()];
            this.common.activateController(promises, ProgramSearch.controllerId).finally(() => {
                this.loading = false;
            });
        }

        getState() {
            if (this.$location.state()) {
                this.searchTerm = this.$location.state().searchTerm;
                this.restResult = this.$location.state().restResult ? JSON.parse(this.$location.state().restResult) : null;
                this.page = this.$location.state().page ? this.$location.state().page : 1;
                this.careerClusterId = this.$location.state().careerClusterId ? this.$location.state().careerClusterId : null;

                this.searchType = this.$location.state().searchType ? this.$location.state().searchType : null;
                this.searchId = this.$location.state().searchId ? this.$location.state().searchId : null;
            }

            if (this.restResult == null) {
                this.search(this.page);
            }
        }

        saveState() {
            var state = {
                searchTerm: this.searchTerm,
                restResult: JSON.stringify(this.restResult),
                page: this.page,
                searchType: this.searchType,
                searchId: this.searchId
            };


            this.$location.search({ s: this.searchTerm, p: this.page, searchType: this.searchType, searchId: this.searchId, occCode: this.occCode });
            return this.$location.state(state);
        }

        getCareerClusters() {
            return this.Restangular.all("programsMajors").one("clusters").get()
                .then((result: ICareerCluster[]) => {
                    this.careerClusters = result;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getCareers(params: any | string) {
            if (typeof (params) == "string") {
                return this.Restangular.oneUrl("programsMajors", params).get()
                    .then((result) => {
                        this.restResult = result;
                        this.saveState();
                    }, (reason) => {
                        this.logError(reason.message, reason, true);
                    });
            }
            else {
                return this.Restangular.all("programsMajors").one("programs").get(params)
                    .then((result) => {
                        this.restResult = result;
                        this.saveState();
                    }, (reason) => {
                        this.logError(reason.message, reason, true);
                    });
            }
        }

        saveProgram(program: any): ng.IPromise<void> {
            return this.Restangular.all("programsMajors").all("saveProgram").post(program)
                .then((result) => {
                    program.isSaved = !program.isSaved;
                    var message = program.isSaved ? 'Program saved successfully.' : 'Program removed successfully.';
                    this.logSuccess(message, '', true);
                },
                    (reason) => {
                        this.logError(reason, reason, true);
                    });
        }

        search(page) {
            this.resetSearch(false);
            this.page = page;

            var params = this.getParams()

            this.getCareers(params);
        }

        gotoPage(page) {
            this.page = page;
            var params = this.getParams();

            this.getCareers(params);
        }

        selectSearchType(searchType: string, id: number) {
            this.searchType = searchType;
            this.searchId = id;

            var params = this.getParams();

            this.getCareers(params);
        }


        resetSearch(clearSearchTerm?: boolean) {
            if (clearSearchTerm) {
                this.searchTerm = null;
            }

            this.searchType = null;
            this.searchId = null;
        }

        nextPage() {
            this.page += 1;
            this.getCareers(this.restResult.nextPageLink);
        }

        prevPage() {
            this.page -= 1;
            this.getCareers(this.restResult.prevPageLink);
        }

        getParams() {
            return {
                search: this.searchTerm,
                pageSize: this.pageSize,
                page: this.page,
                searchType: this.searchType,
                searchId: this.searchId,
                occCode: this.occCode
            }
        }
    }

    angular.module("app").controller(ProgramSearch.controllerId, ProgramSearch);
}